import { render, staticRenderFns } from "./ModalUpdateStats.vue?vue&type=template&id=7049dde5&scoped=true"
import script from "./ModalUpdateStats.vue?vue&type=script&lang=js"
export * from "./ModalUpdateStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7049dde5",
  null
  
)

export default component.exports